var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmlspy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "XMLSpy",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7 29c0 15.7-12.8 28.5-28.5 28.5C13.4 57.5.7 44.7.7 29S13.5.5 29.2.5 57.7 13.3 57.7 29z",
    fill: "#f51437"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44 35-5.9-5.9 5.7-5.7c1.3-1.1 2.1-2.8 2.1-4.7 0-3.5-2.8-6.3-6.3-6.3-1.7 0-3.3.7-4.4 1.8l-5.9 5.9-5.9-5.9c-1.1-1.1-2.7-1.8-4.4-1.8-3.5 0-6.3 2.8-6.3 6.3 0 1.8.7 3.4 1.9 4.5l5.8 5.8-6 6c-1.1 1.1-1.8 2.7-1.8 4.4 0 3.5 2.8 6.3 6.3 6.3 1.8 0 3.4-.7 4.5-1.9l5.8-5.8 5.7 5.7c1.1 1.3 2.8 2.1 4.7 2.1 3.5 0 6.3-2.8 6.3-6.3-.1-1.8-.8-3.4-1.9-4.5z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 36.9-7.7-7.7 7.7-7.7c.7-.7 1.1-1.6 1.1-2.6 0-2-1.6-3.6-3.6-3.6-1.1 0-2 .4-2.7 1.2l-10.2 10c-.7.7-1.2 1.6-1.2 2.7 0 .9.3 1.8.9 2.4l.2.2 10.1 10.1c.7.7 1.6 1.2 2.7 1.2 2 0 3.7-1.6 3.7-3.6 0-1.1-.4-2-1-2.6z",
    fill: "#aa0041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlspy);
export default __webpack_public_path__ + "static/media/xmlspy.e805f271671456fe089c1116b7f06c78.svg";
export { ForwardRef as ReactComponent };